// extracted by mini-css-extract-plugin
export default {"header":"PartsAddItem_header__Ih5+o","loading":"PartsAddItem_loading__igbT3"};